export default class AddReflectionCommentCtrl {
  constructor ($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv) {
  // constants
    var reflectionCommentVm = this
    const sharedVar = PortfolioModalSrv.getVariable()

    reflectionCommentVm.userId     = sharedVar.guestUser
    reflectionCommentVm.reflection = sharedVar.reflection
    reflectionCommentVm.isExternal = sharedVar.isExternal
  // variables
    reflectionCommentVm.comment = ''
    reflectionCommentVm.disableButton = false

  // methods
    reflectionCommentVm.close             = close
    reflectionCommentVm.addComment        = addComment
    reflectionCommentVm.showErrorMessages = showErrorMessages
    reflectionCommentVm.hasError          = hasError
    reflectionCommentVm.validateForm      = validateForm    

    function close () {
      PortfolioModalSrv.setVariable({status : false})
      return $mdDialog.hide()
    }  

    function addComment () {
      reflectionCommentVm.disableButton = true
      let header = {
        userId       : reflectionCommentVm.userId,
        comment      : reflectionCommentVm.comment,
        reflectionId : reflectionCommentVm.reflection.blogId
      }
      PortfolioSrv.addReflectionComment.add(header).$promise.then((dataReturn) => {
        if (dataReturn.status) {
          PortfolioModalSrv.setVariable({status : dataReturn.status})
          return $mdDialog.hide()          
        }else {
          reflectionCommentVm.disableButton = false
        }
      })
    }

    function hasError (input) {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function showErrorMessages (input) {
      return input.$dirty || input.$touched
    }

    function validateForm (form) {
      return form.$invalid
    }
  }
}

AddReflectionCommentCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/myPortfolio/modals/addReflectionCommentCtrl.js